const normalize = (value) => String(value || '').trim().toLowerCase()

const projectMatchesQuery = (project, query) => normalize(project?.name).includes(query)

const taskMatchesQuery = (task, query) => {
  const haystacks = [
    task?.name,
    task?.assigneeName,
    task?.deliverableName,
    task?.projectName,
    task?.statusLabel,
  ]

  return haystacks.some((value) => normalize(value).includes(query))
}

export const filterProjectTree = (projects, rawQuery) => {
  const query = normalize(rawQuery)
  if (!query) return projects

  return projects
    .map((project) => {
      const projectHit = projectMatchesQuery(project, query)
      const visibleTasks = projectHit
        ? project.tasks
        : project.tasks.filter((task) => taskMatchesQuery(task, query))

      if (!projectHit && visibleTasks.length === 0) return null

      return {
        ...project,
        projectMatched: projectHit,
        visibleTasks,
      }
    })
    .filter(Boolean)
}

export const flattenVisibleRows = (projects, expandedProjectIds, rawQuery = '') => {
  const hasActiveQuery = normalize(rawQuery).length > 0
  const rows = []

  projects.forEach((project) => {
    const visibleTasks = project.visibleTasks ?? project.tasks ?? []
    const hideProjectRowInFilteredTaskMode =
      hasActiveQuery && !project.projectMatched && visibleTasks.length > 0

    if (!hideProjectRowInFilteredTaskMode) {
      rows.push({
        id: `project-${project.id}`,
        rowType: 'project',
        projectId: project.id,
        project,
        timelineItem: project.timelineItem,
        tasksCount: visibleTasks.length,
      })
    }

    if (!expandedProjectIds.has(project.id)) return

    visibleTasks.forEach((task) => {
      rows.push({
        id: `task-${task.id}`,
        rowType: 'task',
        projectId: project.id,
        project,
        task,
        timelineItem: task.timelineItem,
        timelineItems: task.timelineItems,
      })
    })
  })

  return rows
}
